<template>
  <div class="login-bg">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 text-center">
          <h2
            v-bind:style="{
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
            }"
          >
            {{ tagline }}
          </h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="card rounded-lg">
          <b-row class="mt-2 ml-2">
            <div class="logo">
              <div class="login-heading" style="font-weight: bold">
                {{ $t("createYourAccount") }}
              </div>
              <!-- <img src="/img/navbar/logo.png" alt="Logo" /> -->
            </div>
          </b-row>
          <div class="card-body pl-5 pr-5">
            <div class="row justify-content-md-center">
              <div class="text-center">
                <form class="mt-4 mb-4">
                  <input
                    ref="otp1"
                    v-model="otpInput1"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput2"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput3"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    class="otp border"
                    type="text"
                    maxlength="1"
                  />
                  <input
                    v-model="otpInput4"
                    class="otp border"
                    v-on:keyup="$event.target.nextElementSibling.focus()"
                    type="text"
                    maxlength="1"
                  />
                </form>
                <p :style="{ color: otpMsg.key }">
                  {{ otpMsg.value }}
                </p>
              </div>
            </div>
            <div class="form-group pt-3 pb-2 text-center">
              <b-button
                class="primary-btn"
                size="lg"
                @click="() => loginOtp()"
                >{{ $t("verifyOTP") }}</b-button
              >
            </div>
            <!-- <div class="text-center pt-2" v-if="!otpKey">
              <p>
                Already Have An Account?
                <router-link
                  :to="{ name: 'login' }"
                  style="text-decoration: underline"
                  >Login</router-link
                >
              </p>
            </div> -->
            <div class="d-flex justify-content-center gap-3 mt-4">
              <!-- Phone -->
              <b-button
                variant="light"
                class="circle-btn border"
                @click="$router.push('/login?type=otp')"
              >
                <b-icon icon="telephone-fill" font-scale="1.2"></b-icon>
              </b-button>

              <!-- Google -->
              <b-button
                variant="light"
                class="circle-btn border"
                @click="googleLogin"
              >
                <img
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                  alt="Google"
                  class="icon-img"
                />
              </b-button>

              <!-- Facebook -->
              <b-button
                variant="light"
                class="circle-btn border"
                @click="facebookLogin"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                  alt="Facebook"
                  class="icon-img"
                />
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { socialLoginSignup } from "../auth.services";
import {
  GoogleAuthProvider,
  FacebookAuthProvider,
  getAuth,
  signInWithPopup,
} from "firebase/auth";
import config from "/public/config.json";
export default {
  data() {
    return {
      appName: config.appName,
      tagline: config.tagline,
      text: "",
      otpMsg: { value: "", key: "" },
      otpKey: false,
      otpInput1: "",
      otpInput2: "",
      otpInput3: "",
      otpInput4: "",
      selected: false,
      fname: "Guest",
      lname: "User",
      phone: null,
      answer: "Default",
      email: null,
      question: "Default",
      password: null,
      confirmPassword: null,
      userName: null,
      errorMessages: "",
      showPassword: false,
      showPassword1: false,
      userId: "",
      errorMessage: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) => /^[A-Z]/.test(v) || "Password must start with a capital letter",
        (v) => /[a-z]/.test(v) || "Password must contain a lowercase letter",
        (v) => /[0-9]/.test(v) || "Password must contain a number",
        (v) => /[\W_]/.test(v) || "Password must contain a special character",
      ],
    };
  },
  computed: {
    confirmPasswordRules() {
      return [
        (v) => !!v || "Confirm Password is required",
        (v) => v === this.password || "Passwords must match",
      ];
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordVisibility1() {
      this.showPassword1 = !this.showPassword1;
    },
    async loginOtp() {
      this.isLoading = true;
      const otp =
        this.otpInput1 + this.otpInput2 + this.otpInput3 + this.otpInput4;
      if (!otp || otp.length !== 4) {
        this.otpMsg = {
          value: "Please enter a valid 4-digit Verification Code",
          key: "red",
        };
        this.isLoading = false;
        return;
      }
      if (!this.text || !this.password) {
        this.$swal({
          type: "error",
          title: "Missing Data",
          text: "Try to create account again",
        });
        return;
      }
      const payload = { otp };
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.text);
      const isPhone = /^[6-9]\d{9}$/.test(this.text);
      let action;
      if (isEmail) {
        payload.email = this.text;
        payload.password = this.password;
        action = "auth/verifyEmailOtp";
      } else if (isPhone) {
        payload.phone = this.text;
        payload.password = this.password;
        action = "auth/verifyEmailOtp";
      } else {
        this.otpMsg = { value: "Invalid email or phone number", key: "red" };
        this.isLoading = false;
        return;
      }
      try {
        const result = await this.$store.dispatch(action, payload);
        const token = result.data.response.token;
        const user = result.data.response.user;

        localStorage.setItem(
          `${process.env.VUE_APP_TENANT}:access_token`,
          token,
        );
        localStorage.setItem(
          `${process.env.VUE_APP_TENANT}:userInfo`,
          JSON.stringify(user),
        );

        this.$store.dispatch("auth/loginToken", token);
        this.$store.dispatch("auth/setUserData", user);
        this.$store.commit("address/setDeliveryAddress", user.addresses);
        sessionStorage.removeItem(`${process.env.VUE_APP_TENANT}:otp_data`);
        setTimeout(() => {
          this.$router.push("/");
          this.isLoading = false;
        }, 1500);
      } catch (err) {
        console.error(err);

        // Check if the error message contains the duplicate key error
        if (
          err.response?.data?.message?.includes("E11000 duplicate key error") ||
          err.response?.data?.message?.includes(
            "parameter authentication.email must be unique",
          ) ||
          err.response?.data?.message?.includes(
            "parameter authentication.phone must be unique",
          )
        ) {
          this.otpMsg = {
            value:
              "This user is already registered. Please use a different email/phone or log in.",
            key: "red",
          };
        } else {
          this.otpMsg = { value: "Invalid Verification", key: "red" };
        }

        this.isLoading = false;
      }
    },
    timerFunc() {
      this.countDownObj.countDownVar = 60;
      this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
      clearInterval(countDownIntervalFunc);
      const countDownIntervalFunc = setInterval(() => {
        this.countDownObj.countDownVar--;
        if (this.countDownObj.countDownVar < 10) {
          this.countDownObj.msg = `00 : 0${this.countDownObj.countDownVar}`;
        } else if (this.countDownObj.countDownVar > 10) {
          this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
        }
        if (this.countDownObj.countDownVar < 0) {
          clearInterval(countDownIntervalFunc);
        }
      }, 1000);
    },
    googleLogin() {
      const x = new GoogleAuthProvider();
      signInWithPopup(getAuth(), x)
        .then(async (res) => {
          try {
            let result = await socialLoginSignup({
              data: {
                accessToken: res._tokenResponse.oauthIdToken,
              },
              type: "GOOGLE",
            });
            if (result.data.response.registration) {
              result = await socialLoginSignup({
                data: {
                  accessToken: res._tokenResponse.oauthIdToken,
                  category: "CUSTOMER",
                },
                type: "GOOGLE",
              });
            }
            result.data.response.user.name.first = res._tokenResponse.firstName;
            result.data.response.user.name.last = res._tokenResponse.lastName;
            // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
            const userdata = {
              ...result.data.response.user,
              loginType: "social",
            };
            if (result) {
              const token = await result.data.response.token;
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token,
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(userdata),
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch("auth/setUserData", userdata);
              this.$store.commit(
                "address/setDeliveryAddress",
                userdata.addresses,
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 1500);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log("google err", err);
        });
    },
    facebookLogin() {
      const x = new FacebookAuthProvider();
      signInWithPopup(getAuth(), x)
        .then(async (res) => {
          const credential = FacebookAuthProvider.credentialFromResult(res);
          const accessToken = credential.accessToken;
          try {
            let result = await socialLoginSignup({
              data: {
                accessToken: accessToken,
              },
              type: "FACEBOOK",
            });

            if (result.data.response.registration) {
              result = await socialLoginSignup({
                data: {
                  accessToken: accessToken,
                  category: "CUSTOMER",
                },
                type: "FACEBOOK",
              });
            }
            result.data.response.user.name.first = res._tokenResponse.firstName;
            result.data.response.user.name.last = res._tokenResponse.lastName;
            // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
            const userdata = {
              ...result.data.response.user,
              loginType: "social",
            };
            if (result) {
              const token = await result.data.response.token;
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token,
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(userdata),
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch("auth/setUserData", userdata);
              this.$store.commit(
                "address/setDeliveryAddress",
                userdata.addresses,
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 1500);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log("google err", err);
        });
    },
  },
  mounted() {
    this.$refs.otp1?.focus();
    const obj = sessionStorage.getItem(`${process.env.VUE_APP_TENANT}:otp_data`)
      ? JSON.parse(
          sessionStorage.getItem(`${process.env.VUE_APP_TENANT}:otp_data`),
        )
      : {};
    this.text = obj.text || "";
    this.password = obj.password || "";
  },
};
</script>

<style scoped>
.login-heading {
  margin-left: 40px;
}
.logo p {
  font-size: 1rem;
}
.toggle-password {
  position: absolute;
  top: 70%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 1.25rem;
  z-index: 10;
  line-height: 1;
}

::v-deep .v-messages__message {
  color: red;
}
.login-bg {
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 1rem;
}
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scaleX(-1);
  z-index: -1;
  opacity: 0.4;
}
.container {
  min-height: 100%;
}
.circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.icon-img {
  height: 24px;
  width: 24px;

  object-fit: contain;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px !important;
    padding: 0 10px;
  }
  .primary-btn {
    width: 100%;
    font-size: 16px;
    white-space: normal;
  }
  .card {
    margin: 20px auto;
    padding: 20px 15px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .v-input input {
    font-size: 16px;
  }

  .checkbox p {
    font-size: 13px;
  }

  .primary-btn {
    font-size: 16px;
    padding: 0.75rem;
  }

  .logo img {
    width: 60px;
  }
  form input {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
  }
  .login-heading {
    font-size: 1.25rem;
  }
}
@media (max-width: 465px) and (min-width: 320px) {
  .login-heading {
    font-size: 1.25rem;
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .login-heading {
    font-size: 2rem;
  }
}
@media (min-width: 1025px) {
  .login-heading {
    font-size: 2rem;
  }
}
.modal-title-otp {
  color: #579a70;
  cursor: pointer;
}

.modal-title-otp a:hover {
  text-decoration: underline !important;
}
.otp {
  margin-right: 10px;
}
.border {
  border: 1px solid #000;
}
form input {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-align: center;
}

.password-field >>> .v-input__append-inner {
  cursor: pointer;
}

.password-field >>> .v-icon {
  background: none !important;
  padding: 0 !important;
  margin-right: 4px;
  color: #666;
}
.card {
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.primary-btn {
  background: var(--primarycolor);
  color: #fff;
  border-color: var(--primarycolor);
  padding: 0.5rem 2rem;
  width: 100%;
}

.logo img {
  max-width: 100px;
  max-height: 100px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}
</style>
